import { BaseUseQueryParameters } from "../BaseUseQueryParameters"
import { useQuery  } from "react-query";
import { keys } from "./Keys";
import GroupMarketingReportDataService from "../../services/group-marketing-report-service/GroupMarketingReportDataService";
import { RestError } from "../../services/rest-service/RestService";
import { ITagAssociationType } from "../../common/models/ITagAssociationType";

export type UseGetGroupMarketingReportQueryParameters = {
    groupID: number,
    
} & BaseUseQueryParameters<ITagAssociationType[]>

export function useGetGroupMarketingReportTats (
    params: UseGetGroupMarketingReportQueryParameters
) {
    return useQuery<ITagAssociationType[], RestError>(
        keys.tats(params.groupID),
        ({ signal }) => {
            return GroupMarketingReportDataService.getGroupMarketingReportTats(params.groupID, signal);
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
        }
    )
}